import {ControlStatusEnum} from '../enums/control-status.enum';
import {ControlTypeEnum} from '../enums/control-type.enum';
import {RiskRegisterControlLinkType} from '../enums/riskRegisterControlLinkType.enum';
import { ControlAgentDto } from './controlAgent.model';

export class Control {
    id: string;
    code: string;
    name: string;
    controlType: ControlTypeEnum;
    controlHierarchyBucketId?: string;
    controlHierarchyBucketName?: string;
    status: ControlStatusEnum;
    ownerUserId?: string;
    ownerName: string;
    notes: string;
    isActive: boolean;
    createdByUserId: string;
    dateCreated: Date;
    dateUpdated: Date;
    updatedByUserId: string;
    isDeleted: boolean;
    deletedDate?: Date;
    deletedByUserId: string;
    controlAgents: ControlAgentDto[];
    riskRegisterControlLinkType?: RiskRegisterControlLinkType;
}
